import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { CreateRegistrationPayload } from '../interfaces/create-registration-payload';
import { StudentProfile } from '../interfaces/student-profile';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StudentProfileDataService {

  constructor(
    private http: HttpClient
  ) { }

  private urlStudentProfile = environment.urlWebServices + '/cwk/student-profile';

  // Create a registration
  createRegistration(studentId: number, competitionId: number, payload: CreateRegistrationPayload): Observable<string> {

    // Call web service
    const url = `${this.urlStudentProfile}/${studentId}/register/${competitionId}`;
    return this.http.put<string>(url, payload)
      .pipe(catchError(error => observableThrowError(error)));
  }

  // Read profile
  readProfile(studentId: number): Observable<StudentProfile> {

    // Call web service
    const getURL = `${this.urlStudentProfile}/${studentId}`;
    return this.http.get<StudentProfile>(getURL)
      .pipe(
        map(response => this.fixStudentProfileFromMySQL(response)),
        catchError(error => observableThrowError(error.message || error))
      );
  }

  private fixStudentProfileFromMySQL(response) {

    const data = structuredClone(response);

    // Fix all competitions
    data.Competitions.forEach(competition => {

      // Parse rounds
      competition.CompetitionRounds = JSON.parse(competition.CompetitionRounds);
      competition.CompetitionRounds.forEach(round => {

        // Fix dates
        round.EndUTC = new Date(round.EndUTC.replace(/ /g, 'T') + 'Z');
        round.StartUTC = new Date(round.StartUTC.replace(/ /g, 'T') + 'Z');
      });

      // Fix dates
      competition.EndUTC = new Date(competition.EndUTC.replace(/ /g, 'T') + 'Z');
      competition.StartUTC = new Date(competition.StartUTC.replace(/ /g, 'T') + 'Z');
    });

    // Fix upcoming competition
    if (data.Upcoming) {

      // Parse rounds
      data.Upcoming.CompetitionRounds = JSON.parse(data.Upcoming.CompetitionRounds);
      data.Upcoming.CompetitionRounds.forEach(round => {

        // Fix dates
        round.EndUTC = new Date(round.EndUTC.replace(/ /g, 'T') + 'Z');
        round.StartUTC = new Date(round.StartUTC.replace(/ /g, 'T') + 'Z');
      });

      // Fix dates
      data.Upcoming.EndUTC = new Date(data.Upcoming.EndUTC.replace(/ /g, 'T') + 'Z');
      data.Upcoming.StartUTC = new Date(data.Upcoming.StartUTC.replace(/ /g, 'T') + 'Z');
    }

    return data;
  }
}
